const screenCmsRouter = [
  {
    path: '/screenCmsLogin',
    name: 'screenCmsLogin',
    meta: {
      title: '登录页'
    },
    component: () => import('../views/OperationManage/Login.vue')
  },
  {
    path: '/screenCmsHome',
    name: 'screenCmsHome',
    meta: {
      title: '首页'
    },
    component: () => import('../views/OperationManage/Home.vue')
  },
  {
    path: '/WatertMonitor',
    name: 'WatertMonitor',
    meta: {
      title: '水养监控'
    },
    component: () => import('../views/OperationManage/WatertMonitor.vue')
  },
  {
    path: '/PieceProduct',
    name: 'PieceProduct',
    meta: {
      title: '管片年度生产'
    },
    component: () => import('../views/OperationManage/PieceProduct.vue')
  },
  {
    path: '/RestMonitor',
    name: 'RestMonitor',
    meta: {
      title: '静养监控'
    },
    component: () => import('../views/OperationManage/RestMonitor.vue')
  },
  {
    path: '/YardMonitor',
    name: 'YardMonitor',
    meta: {
      title: '堆场监控'
    },
    component: () => import('../views/OperationManage/YardMonitor.vue')
  },
  {
    path: '/DuctDespatch',
    name: 'DuctDespatch',
    meta: {
      title: '管片发运'
    },
    component: () => import('../views/OperationManage/DuctDespatch.vue')
  }
]

export default screenCmsRouter
